import { render, staticRenderFns } from "./Microfone.vue?vue&type=template&id=21a028ca&"
import script from "./Microfone.vue?vue&type=script&lang=js&"
export * from "./Microfone.vue?vue&type=script&lang=js&"
import style0 from "./Microfone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports